module.exports = "/_next/static/images/38ef072dd352bfc02cdcaaadf5a2644e-google-wallet-mini.png";